import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || window.API_URL;

const $host = axios.create({
    baseURL: API_URL,
});

const authInterceptor = (config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;

    if (config.data instanceof FormData) {
        // Let axios set multipart/form-data with boundary.
        delete config.headers["Content-Type"];
    } else {
        config.headers["Content-Type"] = `application/json`;
    }

    return config;
};

$host.interceptors.request.use(authInterceptor);

// Позволяет приложению подписаться на событие 401 (Unauthorized)
let unauthorizedHandler = null;
export const setOnUnauthorized = (handler) => {
    unauthorizedHandler = typeof handler === "function" ? handler : null;
};

$host.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        const apiError = error?.response?.data;

        // Глобальная обработка 401: сбрасываем токен и дергаем колбэк из контекста
        if (status === 401) {
            try {
                localStorage.removeItem("token");
                if (unauthorizedHandler) unauthorizedHandler();
            } catch (e) {
                // не ломаем цепочку, если хендлер упал
                console.error("Unauthorized handler error:", e);
            }
        }

        if (apiError) {
            const normalizedError = {
                code: apiError.code ?? "UNKNOWN_ERROR",
                message: apiError.error ?? "Произошла неизвестная ошибка",
                // details: apiError.details ?? null,
                status: status ?? 500,
                originalError: error,
            };

            // 💡 Кидаем нормализованную ошибку — не оригинальный AxiosError
            return Promise.reject(normalizedError);
        }

        return Promise.reject({
            code: "NETWORK_ERROR",
            message: "Ошибка сети или сервера",
            details: null,
            status: status ?? 0,
            originalError: error,
        });
    },
);

export { $host };
